import global from '@/assets/js/global'
import axios from 'axios'

const path = 'firestoreSchool/lottery'

/*
 *  LOTTERY
 */

const get = async (params, token) => {
  const options = {
    params,
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)
  return res.data
}

const put = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.put(`${global.server}${path}`, body, options)
  return res.data
}

// 刪除
const remove = async (data, token) => {
  const options = {
    headers: { authorization: token },
    data,
  }
  const res = await axios.delete(`${global.server}${path}`, options)
  return res.data
}

// 新增
const post = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }

  const res = await axios.post(`${global.server}${path}`, body, options)

  return res.data
}

// 抽出獎項
const draw = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.post(`${global.server}setLottery`, body, options)
  return res.data
}

export default {
  get,
  put,
  remove,
  post,
  draw,
}
